export default __webpack_public_path__ + "static/media/logoWhite.8da96cf5.png";